import classNames from 'classnames';
import React from 'react';
import { usePatchedDropdownMenu } from '../../../utils/usePatchedDropdownMenu';

interface IRamsOption {
    text: string;
    textLine2?: undefined | string;
    textLine3?: undefined | string;
    value: string;
    priorityValue?: undefined | string;
}

type Props = {
    name: string;
    header?: undefined | string;
    value?: undefined | string;
    options: IRamsOption[];
    topLabel?: undefined | string;
    subText?: undefined | string;
    handleChange: (value: string, name: string, priorityValue: string) => void;
};

export function RamssheepDropdownNen(props: Props) {
    const arrayMenuItemsShift = props.header ? 1 : 0;
    const menuItemsAmount = arrayMenuItemsShift + props.options.length;
    const { buttonProps, itemProps, isOpen, setIsOpen } = usePatchedDropdownMenu(menuItemsAmount);
    const containerClasses = classNames('btn-group', { open: isOpen });

    const firstMenuItemHandler = (): void => {
        setIsOpen(false);
        // NOTE: TS is complaining so we forced to do type enforcement
        // TODO need to take a look at them
        props.handleChange(null as unknown as string, props.name, null as unknown as string);
    };

    const othersMenuItemsHandler = (option: IRamsOption): void => {
        setIsOpen(false);
        // NOTE: TS is complaining so we forced to do type enforcement
        // TODO need to take a look at it
        props.handleChange(option.value, props.name, option.priorityValue as string);
    };

    return (
        <span style={{ float: 'left' }} className="mh10">
            {props.topLabel && (
                <div className="pv5 ph10">
                    <strong>{props.topLabel}</strong>
                </div>
            )}
            <div className={containerClasses}>
                <button
                    {...buttonProps}
                    className={`btn btn-primary btn-sm fs12 fw500 dropdown-toggle ph10 rams${getPriorityValue(props.options, props.value)}`}
                    data-toggle="dropdown"
                    type="button"
                >
                    {props.value ?? '_'}
                </button>
                <ul className="dropdown-menu pull-right" role="menu">
                    {props.header && (
                        <li {...itemProps[0]} onClick={firstMenuItemHandler}>
                            <a className="cursor edit-element" style={{ color: '#000' }}>
                                <strong>{props.header}</strong>
                                {props.subText && <div className="fs12 text-muted">{props.subText}</div>}
                            </a>
                        </li>
                    )}

                    {props.options.map((option, i) => (
                        <li
                            key={i}
                            {...itemProps[i + arrayMenuItemsShift]}
                            className={option.value === props.name ? 'bg-light darker' : ''}
                            onClick={() => othersMenuItemsHandler(option)}
                        >
                            <a className="cursor edit-element">
                                {option.value === props.name ? (
                                    <strong>
                                        {option.value}:&nbsp;&nbsp;{option.text}
                                    </strong>
                                ) : (
                                    <>
                                        {option.value}:&nbsp;&nbsp;{option.text}
                                        {option.textLine2 && <div>{option.textLine2}</div>}
                                        {option.textLine3 && <div>{option.textLine3}</div>}
                                    </>
                                )}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </span>
    );
}

function getPriorityValue(options: IRamsOption[], value?: string) {
    const optionItem = options.find((item) => item.value === value);
    if (optionItem) {
        return optionItem.priorityValue;
    }

    return '0';
}
